if (!customElements.get('fsm-footer')) {
  customElements.define('fsm-footer', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort(); this.abort = new AbortController();
      const mq = matchMedia('(max-width:749px)');
      const update = () => this.querySelectorAll('.fsm-footer-fold').forEach(d => {
        d.open = !mq.matches || d.dataset.mobileCollapse !== 'true';
        d.querySelector('summary').tabIndex = mq.matches ? 0 : -1;
      });
      update(); mq.addEventListener('change', update, {signal:this.abort.signal});
      this.addEventListener('shopify:block:select', e => {
        const fold=e.target.querySelector('.fsm-footer-fold'); if(fold) fold.open=true;
      }, {signal:this.abort.signal});
    }
    disconnectedCallback(){this.abort?.abort();}
  });
}
